import { apiFetch } from '@/api/request'
import type { ApiResponse } from '@/types/verification'

export type PublicLoginKind = 'member' | 'seller' | 'admin'

export interface ResolveLoginPayload {
  userId: string
  password: string
}

export interface ResolveLoginResult {
  kinds: PublicLoginKind[]
}

const API_ORIGIN = (process.env.VUE_APP_API_ORIGIN || '').replace(/\/$/, '')
const BASE = `${API_ORIGIN}/api/login`

const fetchOptions: RequestInit = {
  credentials: 'include',
}

async function parseJson<T>(response: Response): Promise<ApiResponse<T>> {
  const contentType = response.headers.get('content-type') || ''
  if (!contentType.includes('application/json')) {
    throw new Error('API 서버에 연결할 수 없습니다. 백엔드(3002)와 프론트 dev 서버를 확인해 주세요.')
  }

  const data = (await response.json()) as ApiResponse<T>
  if (!response.ok && !data.message) {
    throw new Error('요청 처리에 실패했습니다.')
  }
  return data
}

export async function resolvePublicLogin(payload: ResolveLoginPayload) {
  const response = await apiFetch(`${BASE}/resolve`, {
    ...fetchOptions,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  const result = await parseJson<ResolveLoginResult>(response)
  if (!result.success || !result.data) {
    throw new Error(result.message || '로그인에 실패했습니다.')
  }
  return result.data.kinds
}
